import { Component, Inject, inject } from '@angular/core';
import { MAT_SNACK_BAR_DATA, MatSnackBarRef } from '@angular/material/snack-bar';

export interface SnackbarComponentData {
  type: 'success' | 'info' | 'error'
  message: string
  color?: string
}

@Component({
  selector: 'app-snackbar',
  templateUrl: 'snackbar.component.html',
  styleUrls: ['snackbar.component.scss'],
})
export class SnackbarComponent {
  type: 'success' | 'info' | 'error' = 'success';
  message!: string;
  color: string | undefined;

  constructor(@Inject(MAT_SNACK_BAR_DATA) public data: SnackbarComponentData) {
    this.type = data.type
    this.message = data.message
    this.color = data.color
  }

  snackBarRef = inject(MatSnackBarRef);
}